import styles from './UserLink.module.scss';

export interface Props {
  language?: 'ja' | 'en';
  name: string;
  nameSuffix?: 'san' | 'sama';
  url: string;
}
const SuffixDisplayMap = {
  ja: { san: 'さん', sama: '様' },
  en: { san: 'san', sama: 'sama' },
};

const UserLink = ({ language = 'ja', url, name, nameSuffix }: Props) => (
  <a className={styles['user-link']} href={url}>
    {name}
    {nameSuffix && (
      <span className={styles['user-suffix']}>{SuffixDisplayMap[language][nameSuffix]}</span>
    )}
  </a>
);

export default UserLink;
